import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import type { Employee } from "~/providers/employee-provider";
import { useEmployeeManager } from "~/managers/use-employee-manager";
import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useEmployeeStore } from "~/stores/use-employee-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import EmployeeForm from "./employee-form";

export default function EmployeeDialog() {
  const { t } = useTranslation("common");

  const { deleteEmployee } = useEmployeeManager();

  const {
    employeeDialogOpen,
    selectedEmployee,
    setEmployeeDialogOpen,
    setSelectedEmployee,
  } = useEmployeeStore();

  const { checkUnsavedChanges } = useUnsavedChanges();

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) {
          setEmployeeDialogOpen(true);
          return;
        }
      }
      setSelectedEmployee(undefined);
    }
    setEmployeeDialogOpen(open);
  };

  const handleDelete = async (employee: Employee) => {
    const result = await deleteEmployee(employee);

    if (result === true) {
      handleDialog(false, true);
    }
  };
  return (
    <Dialog open={employeeDialogOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full">
        <DialogHeader>
          <DialogTitle>{t("Employee.employee")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <EmployeeForm
            onClose={(force) => {
              handleDialog(false, force);
            }}
            employee={selectedEmployee}
          />
        </div>
        <DialogFooter>
          {selectedEmployee && !selectedEmployee.isDefault && (
            <Button
              onClick={() => {
                void handleDelete(selectedEmployee);
              }}
              variant="destructive"
            >
              {t("delete")}
            </Button>
          )}
          <Button form="employee-form" type="submit" variant="success">
            {selectedEmployee ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
